module.exports = "<nv-react-component component=\"AdvancedSettings\"></nv-react-component>";